exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-2fe76b3b] {\n    font-size: 18px;\n}\n.modal-content[data-v-2fe76b3b] {\n    max-height: 80%;\n}\n", ""]);

// exports
